import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2f8df88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "offcanvas offcanvas-end",
  tabindex: "-1",
  id: "offcanvas-menu",
  "aria-labelledby": "offcanvas-menu"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = { class: "offcanvas-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close text-reset",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_5 = { class: "offcanvas-body" }
const _hoisted_6 = { class: "nav flex-column" }
const _hoisted_7 = { class: "custom-feed-row" }
const _hoisted_8 = {
  key: 0,
  class: "feed-action-row"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-share" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Settings ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "https://ology.substack.com/about",
    target: "_blank"
  }, "About")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#add-feed-form"
  }, "Add Feed")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_21 = {
  class: "collapse",
  id: "add-feed-form"
}
const _hoisted_22 = ["onSubmit"]
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Feed Name", -1))
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Feed URL", -1))
const _hoisted_27 = ["disabled"]

import slugify from 'slugify';
import { Offcanvas, Collapse } from 'bootstrap';
import { onMounted, ref, Ref, watch } from 'vue';
import router from '@/router';
import { FeedTemplate, FeedConfig } from '@/types/FeedConfig';
import { useEventsBus } from '@/functions/utility';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const config: Ref<FeedConfig> = ref({
    feeds: {},
    feed_default: {
        name: 'Congress & Senate',
        slug: 'congress-senate',
        url: 'https://feed.ology.com/feed/politics-senators/latest.jsonl',
        canDelete: false
    },
    version: 0,
});

const version = process.env.VUE_APP_VERSION;

const feed_url = ref("");
const feed_name = ref("");

/**
* Create FeedTemplate from Data and Add Feed to Feeds
*/
function addFeed() {
    const slug = slugify(feed_name.value, {
        lower: true,
        strict: true,
        trim: true,
    });

    const feed_config: FeedTemplate = {
        name: feed_name.value,
        slug: slug,
        url: feed_url.value,
        canDelete: true,
    }

    config.value.feeds[slug] = feed_config;
    localStorage.setItem("feed_configuration", JSON.stringify(config.value));

    feed_url.value = "";
    feed_name.value = "";

    //@ts-ignore
    Collapse.getInstance(document.getElementById('add-feed-form')).hide();
}

/**
* Remove Feed from Feeds
*
* @param slug Feed with Slug to remove
*/
function removeFeed(slug: string) {
    delete config.value.feeds[slug];

    localStorage.setItem("feed_configuration", JSON.stringify(config.value));
}

/**
* Add custom feed share url to clipboard
*
* @param slug Feed with Slug to share
*/
function shareFeed(slug: string) {
    const feed = config.value.feeds[slug];

    // get components
    const feed_url = encodeURIComponent(feed.url);
    const feed_name = encodeURIComponent(feed.name);

    // resolve config import route url
    const path = router.resolve({
        name: 'Feed Import',
        query: {
            name: feed_name,
            url: feed_url
        }
    }).fullPath;
    const url = location.protocol + '//' + location.host + path;

    const message = `Added feed import url to clipboard. Anyone who enters the url in their browser will have the custom feed "${feed.name}" added to their web app`;

    navigator.clipboard.writeText(url).then(() => {
        console.log(message, url);

        // emit newAlert with content
        const { emit } = useEventsBus();
        emit('newAlert', message);
    });
}

function closeSidebar() {
    //@ts-ignore
    Offcanvas.getInstance(document.getElementById('offcanvas-menu')).hide();
}

function refreshFeeds() {
    const saved = localStorage.getItem("feed_configuration");

    if (saved) {
        Object.assign(config.value, JSON.parse(saved));
        return true;
    }

    return false
}

onMounted(() => {
    const saved = localStorage.getItem("feed_configuration");

    if (saved) {
        Object.assign(config.value, JSON.parse(saved));
    }

    let newVersion = false;

    if ((config.value.version || false) !== process.env.VUE_APP_CONFIG_VERSION) {
        // we need to change the version
        config.value.version = process.env.VUE_APP_CONFIG_VERSION;
        newVersion = true;
    }

    if (Object.keys(config.value.feeds).length == 0 || newVersion == true) {
        // if there is no feed, these are the default values.
        // or if it's a new version

        delete config.value.feeds.home;

        config.value.feed_default = {
            name: 'Congress & Senate',
            slug: 'congress-senate',
            url: 'https://feed.ology.com/feed/politics-senators/latest.jsonl',
            canDelete: false,
        }

        config.value.feeds['congress-senate'] = {
            name: 'Congress & Senate',
            slug: 'congress-senate',
            url: 'https://feed.ology.com/feed/politics-senators/latest.jsonl',
            canDelete: false,
        }

        delete config.value.feeds['politics-right-leaning'];

        config.value.feeds['politics-right'] = {
            name: 'Politics Right',
            slug: 'politics-right',
            url: 'https://feed.ology.com/feed/politics-right-leaning/latest.jsonl',
            canDelete: false,
        }

        config.value.feeds['politics-left'] = {
            name: 'Politics Left',
            slug: 'politics-left',
            url: 'https://feed.ology.com/feed/politics-left-leaning/latest.jsonl',
            canDelete: false,
        }

        config.value.feeds['political-news-opinion'] = {
            name: 'Political News & Opinion',
            slug: 'political-news-opinion',
            url: 'https://feed.ology.com/feed/politics-mainstream/latest.jsonl',
            canDelete: false,
        }

        localStorage.setItem("feed_configuration", JSON.stringify(config.value));
    }

    // setup event listener for new feeds
    const { bus } = useEventsBus();
    watch(()=> bus.value.get('newFeedConfig'), (val) => {
        // destruct the parameters
        const [ newFeed ] = val ?? []
        console.log(`Received event value: ${newFeed}`);
        refreshFeeds();
    })
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, "Ology Navigation - " + _toDisplayString(_unref(version)), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.feeds, (feed) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item position-relative",
            key: feed.slug
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                onClick: closeSidebar,
                class: "nav-link",
                to: { name: 'Named Feed', params: { feedName: feed.slug } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(feed.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (feed.canDelete !== false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "feed-action-btn btn btn-info btn-sm",
                      onClick: ($event: any) => (shareFeed(feed.slug)),
                      title: "Share Feed"
                    }, _hoisted_11, 8, _hoisted_9),
                    _createElementVNode("button", {
                      class: "feed-action-btn btn btn-danger btn-sm",
                      onClick: ($event: any) => (removeFeed(feed.slug)),
                      title: "Remove Feed"
                    }, _hoisted_14, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _hoisted_15,
        _createElementVNode("li", _hoisted_16, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            onClick: closeSidebar,
            to: { name: 'Settings' }
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _hoisted_18,
        _hoisted_19,
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("form", {
          class: "my-2",
          onSubmit: _withModifiers(addFeed, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((feed_name).value = $event)),
              placeholder: "Feed Name..."
            }, null, 512), [
              [_vModelText, feed_name.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((feed_url).value = $event)),
              placeholder: "Feed URL..."
            }, null, 512), [
              [_vModelText, feed_url.value]
            ])
          ]),
          _createElementVNode("button", {
            disabled: feed_url.value.length === 0 || feed_name.value.length === 0,
            class: "btn btn-primary btn-block mt-2"
          }, " Add Feed ", 8, _hoisted_27)
        ], 40, _hoisted_22)
      ])
    ])
  ]))
}
}

})